<template>
    <div class="filter-list--toggle">
        <UIInputToggle
            :id="filter.key"
            :value="filter.label"
            :checked="!!filter.active"
            @input="
                (val) =>
                    toggleFilter(val, filter.key, filter.value, filter.label)
            "
        >
            <span class="h3">{{ filter.label }}</span>
        </UIInputToggle>
    </div>
</template>
<script>
import UIInputToggle from '@vue/UI/InputToggle'
import FilterListTypeBase from './FilterListTypeBase.vue'

export default {
    components: {
        UIInputToggle
    },
    extends: FilterListTypeBase
}
</script>
<style lang="scss">
.filter-list--toggle {
    padding: 12px 0;
    @media #{$media-to-sm} {
        margin: 12px 0;
        padding: 0;
    }

    .h3 {
        margin: 0;
    }

    .ui-input-toggle__label {
        color: initial;

        .h3 {
            font-size: 14px;
            font-weight: 600;
            line-height: 42px;
        }
    }
}
</style>
